import React from "react"
import { useState } from "react"
import {
  Button,
  Badge,
  Tooltip
} from "reactstrap"

export default (context) => {
  const M = "admBalance."

  const Overview = (props) => {
    // const {L, form} = props
    const [isOpen, setIsOpen] = useState(false);
    
    const toggle = () => {
      setIsOpen(!isOpen)
    };

    return (
      <section>
        <h4>Pay as you go</h4>
        <div className="d-flex mb-1">
          <div>Credit balance</div>
          <i id="Tooltip-Info" className="iconsminds-information"></i>
        </div>
        <Tooltip
          placement="right"
          isOpen={isOpen}
          target={"Tooltip-Info"}
          toggle={toggle}
        >
          ......
        </Tooltip>
        <div className="d-flex align-items-center mb-2">
          <h1 className="m-0 p-0 mr-2">$9.22</h1>
          <Badge className="handle" color="outline-dark" pill>
            25 conversations
          </Badge>
        </div>
        <Button color="primary" size="sm">Add to credit balance</Button>
      </section>
    ) 
  }

  return {
    config: {
      pageSize: 40,
      list: false,
    },

    actions: {
      create: false,
      edit: true,
      delete: false,
      print: false,
      export: false,
      search: false
    },

    extras: {
      forms: [
        {
          type: "customComponent",
          component: Overview
        }
      ]
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.owner = { value: r.data.owner, label: r.data.ownerName }
          r.data.superowner = { value: r.data.superowner, label: r.data.superownerName }
        }
        return r
      },
      fields: [
        {
          col: 12,
          name: "name",
          value: "",
          type: "text",
          label: `${M}gradeName`,
          rules: 'required',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 6,
          name: "owner",
          value: "",
          type: "select",
          label: `${M}gradeAdvisor`,
          rules: 'required',
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 6,
          name: "superowner",
          value: "",
          type: "select",
          label:  `${M}levelCoordinator`,
          opts: {
            style: 'float-label',
            path: "/admStaff/get?pick=true"
          }
        },
        {
          col: 12,
          name: "groupBy",
          value: "",
          type: "text",
          label: `${M}groupedBy`,
          rules: 'max:20',
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "btn1",
          value: null,
          type: "button",
          label: `${M}subLevels`,
          opts: {
            style: 'float-label'
          },
          onClick: (ctx) => {
            ctx.toogleSubGrid(0)
          },
          renderIf: (ctx) => { return context.state.idItemSelected },
        },    
      ],
      subGrids: [
        {
          name: (ctx) => { return 'Secciones: ' + ctx.state.name },
          module: 'admSection',
          filterBy: () => { return { parentId: context.state.idItemSelected } }
        }
      ] 
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.desc",
        accessor: "desc"
      },
      {
        Header: "main.students",
        accessor: "count"
      },
      {
        Header: `${M}groupedBy`,
        accessor: "groupBy"
      }
    ]
  }
}